const eventInspectorSystemTabNames = [
  'Info',
  'Schedules',
  'Location',
  'Team',
  'Resources',
  'Tasks',
  'Prices',
  'Contacts',
  'Attachments',
  'History',
  'Reports',
  'Permissions'
];
const eventInspectorTabPrepend = 'EventInspector-';

/* For now, we do not show these tabs */
const excludedEventInspectorTabs = ['History', 'Permissions', 'Tasks'];

export const getFullEventWidgetTabName = (tabName) => eventInspectorTabPrepend + tabName;

export const isEventInspectorTabExcluded = (tab) =>
  excludedEventInspectorTabs.some(
    (tabName) => eventInspectorTabPrepend + tabName === tab.tabid
  );

export const isTabVisible = (tab, contentPerTab, customDataPerTab) =>
  (!isEventInspectorTabExcluded(tab) && contentPerTab[tab.tabid]) ||
  customDataPerTab[tab.tabid];

export const filterVisibleEventInspectorTabs = (tabs) =>
  tabs.filter((tab) => !isEventInspectorTabExcluded(tab));

export const filterTabsWithoutContent = (tabs, contentPerTab, customDataPerTab) =>
  tabs.filter((tab) => isTabVisible(tab, contentPerTab, customDataPerTab));

export const defaultTabForWidget = (defaultTab, visibleTabs) => {
  if (defaultTab && visibleTabs.find((tab) => tab.tabid === defaultTab.tabid))
    return defaultTab;
  return visibleTabs.length > 0 ? visibleTabs[0] : null;
};
